
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import BaseCard from "@/components/base/BaseCard.vue";
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import { OFFER_TABS, OfferSingle } from "@/services/offers/OfferSingle";
import { translateOffersStatus } from "@/utils/translate";
import { IOffer, IRedirectToOffer } from "@/api/types/offers";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import { getEmployeesOffersV2 } from "@/api/offers";
import { ITableStatus } from "@/types";
import { useOfferDetailStore } from "@/store_v3/offerCard";
import { canEditOffers } from "@/utils/checkRole";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import BaseSelect from "@/components/base/design/BaseSelect.vue";
@Component({
    methods: { getEmployeesOffersV2 },
    components: { BaseSelect, BaseTooltip, BaseAutocomplete, TableWithFrontPaginationDesign, BaseCard },
})

export default class OfferRedirects extends Vue {
    get canEditOffer(): boolean {
        return canEditOffers();
    }

    @Prop({ required: true }) offer!: OfferSingle;
    redirectOffer: IOffer | null = null;
    redirectUrl: number | null = null;
    editMode = false;
    store = useOfferDetailStore();
    OFFER_TABS = OFFER_TABS;
    get headers(): DataTableHeader[] {
        const headers: DataTableHeader[] = [
            { text: 'ID оффера', value: 'legacy_id', align: 'center' },
            { text: 'Название', value: 'name' },
            { text: 'Рекламодатель', sortable: false, value: 'advertiser_name' },
            { text: 'Менеджер', sortable: false, value: 'manager_name' },
            { text: 'Статус', sortable: false, value: 'status' },
        ];
        if (this.canEditOffer) {
            headers.push({ text: '', sortable: false, value: 'actions', align: 'center' });
        }
        return headers;
    }

    actions = [
        {
            title: 'Удалить',
            color: '#1B1B1D',
            icon: 'SvgTrashWhite',
            callback: (item: IRedirectToOffer): void => {
                this.deleteRedirect(item.id);
            },
        },
    ];

    async deleteRedirect(id: number): Promise<void> {
        await this.offer.deleteRedirectToOffer(id);
    }

    routes = [
        {
            routeParam: 'id',
            extraRouteParamName: 'legacy_id',
            slot: 'item.legacy_id',
            routerName: 'offer',
            text: 'legacy_id',
        },
        {
            routeParam: 'id',
            extraRouteParamName: 'legacy_id',
            slot: 'item.name',
            routerName: 'offer',
            text: 'name',
        },
        {
            routeParam: 'id',
            extraRouteParamName: 'advertiser_id',
            slot: 'item.advertiser_name',
            routerName: 'advertiser',
            text: 'advertiser_name',
        },
    ];

    statuses: ITableStatus[] = [
        {
            slot: 'item.status',
            key: 'status',
            translate: translateOffersStatus,
        },
    ];

    get isOfferEmpty(): boolean {
        return Object.keys(this.offer)?.length <= 0;
    }

    get defaultSearchRedirectOffer(): string {
        return this.offer.redirect_offer_id ? String(this.offer.redirect_offer_id) : '';
    }

    get getAdditionalUrl(): { id: number | null, text: string }[] {
        const urls = this.redirectOffer?.additional_urls?.filter(i => i.status !== 'deleted');
        return urls?.length ? urls.map(i => ({ id: i.legacy_id!, text: i.name! })) : [];
    }

    get isDisableRedirectUrl(): boolean {
        return this.getAdditionalUrl.length === 0;
    }

    get getRedirectUrlItems(): { id: number | null, text: string }[] {
        const def = { id: null, text: "По умолчанию" };
        return [def, ...this.getAdditionalUrl];
    }

    selectRedirectUrl(value: number | null): void {
        this.redirectUrl = value;
    }

    getRedirectOfferStatus(item: IOffer): string {
        return item.status ? ' (' + translateOffersStatus(item.status).text + ')' : '';
    }

    getRedirectOffer(item: IOffer): void {
        this.redirectOffer = item ? { ...item } : null;
        if (this.offer.redirect_offer_id === item.legacy_id) {
            this.redirectUrl = this.offer.redirect_url_id!;
        } else {
            this.redirectUrl = null;
        }
    }

    async patchRedirectOffer(): Promise<void> {
        const isSameOffer = this.redirectOffer?.id === this.offer.redirectOffer?.id;
        const isSameURL = this.redirectUrl === this.offer.redirect_offer_id;
        if (isSameOffer && isSameURL) return;
        const isUpdateRedirect = await this.offer.setRedirect(this.redirectOffer?.id!, this.redirectUrl!);
        if (isUpdateRedirect) this.store.setIsUpdateOffer(true);
    }

    get templateOffer(): string {
        return this.offer.fullNameRedirectOffer;
    }

    editInfo(edit: boolean): void {
        if(!edit) {
            this.patchRedirectOffer();
        }
        this.editMode = edit;
    }

    cancelEdit(): void {
        this.editMode = false;
        this.redirectOffer = null;
    }

    @Watch('$route', { immediate: true, deep: true })
    onRouteChange(newVal: any, oldVal: any): void {
        if (oldVal && newVal.name === 'offer' && oldVal.name === 'offer' && newVal.params.id !== oldVal.params.id) {
            this.store.setIsUpdateOffer(true);
            this.store.changeOfferTab(OFFER_TABS.MAIN);
        }
    }
}

